import { useState } from 'react';
import {
  getMoviesApiUrl,
  getUnavailableApiMessage,
  parseJsonResponse,
} from '../../../lib/moviesAdminApi';
import { INITIAL_FAVORITE_FORM_STATE } from '../constants';

const getInitialFavoriteFormState = () => ({ ...INITIAL_FAVORITE_FORM_STATE });

export const useFavoriteSubmission = () => {
  const [formState, setFormState] = useState(getInitialFavoriteFormState);
  const [submitStatus, setSubmitStatus] = useState({ type: 'idle', message: '' });

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormState((currentState) => ({
      ...currentState,
      [name]: value,
    }));
  };

  const handleFavoriteSubmit = async (event) => {
    event.preventDefault();

    if (submitStatus.type === 'saving') {
      return;
    }

    const submittedTitle = formState.title.trim();
    const submittedColumn = formState.column;
    const submittedCategory = formState.category.trim();
    const submittedNote = formState.note.trim();

    if (!submittedTitle) {
      setSubmitStatus({
        type: 'error',
        message: 'Informe um titulo antes de enviar.',
      });
      return;
    }

    if (!submittedCategory) {
      setSubmitStatus({
        type: 'error',
        message: 'Informe uma categoria antes de enviar.',
      });
      return;
    }

    setSubmitStatus({ type: 'saving', message: 'Enviando entrada para o GitHub...' });

    try {
      const response = await fetch(getMoviesApiUrl('/api/movies/favorites'), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: submittedTitle,
          column: submittedColumn,
          category: submittedCategory,
          note: submittedNote,
        }),
      });
      const data = await parseJsonResponse(response);

      if (response.status === 404) {
        setSubmitStatus({
          type: 'error',
          message: getUnavailableApiMessage(),
        });
        return;
      }

      if (!response.ok) {
        setSubmitStatus({
          type: 'error',
          message: data?.error || 'Nao foi possivel salvar essa entrada agora.',
        });
        return;
      }

      setFormState(getInitialFavoriteFormState());
      setSubmitStatus({
        type: 'success',
        message: data?.commitUrl
          ? `Entrada enviada com sucesso. Commit criado em ${data.commitUrl}.`
          : 'Entrada enviada com sucesso para o repositório.',
      });
    } catch (_error) {
      setSubmitStatus({
        type: 'error',
        message: getUnavailableApiMessage(),
      });
    }
  };

  return {
    formState,
    submitStatus,
    handleInputChange,
    handleFavoriteSubmit,
  };
};
